export default __webpack_public_path__ + "static/media/Versions.2e4dce56.svg";